/* eslint-disable no-unused-vars */
import { Formik } from "formik";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getRentContractId, newGetInitialValues, newHasField, newValidate, Translation as T, useAmsSelector } from "@awe-web/shared/lib";

import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "../../../components/grid.js";
import { TypeArea } from "../../../components/layout.js";
import { ScreenHeading, ScreenLoading, ScreenSection } from "../../../components/screen.js";
import { B2B_SignUpRequest, B2C_LTR_SelectProvisioning, B2C_LTR_SubmitRentContract, B2C_SelectStationAndTime, B2C_STR_SubmitRentContract } from "../../../routing/routes.js";
import { AccountFieldset, AddressFieldset, ConsentFieldset, IdentificationAndDriversLicenseFieldset } from "../../../user/components/form.js";
import { useInitialize } from "../../../util/react.js";
import { initializeGuestRegister, submitRegisterAsGuest } from "./actions.js";
import SignUpGuestForm from "./sign_up_guest_form.jsx";
import { setLoginState } from "../../../user/actions.js";
import { getSelectedRentObject } from "../../../rent_objects/store.js";

const REGISTRATION = "FSD0000187";
const INTRODUCTION = "FSD0000188";
const LINK_B2B_SIGN_UP = "ALG0000215";

function SignUpFormWrapper({ onSubmit, onCaptchaChange }) {

    const rentContractId = useSelector((state) => getRentContractId(state));

    const hasField = useAmsSelector((state) => newHasField("guestRegistration")(state));

    const validate = useAmsSelector((state) => newValidate("guestRegistration", {
        "AlternativeWebLogin:Login": "Address:email"
    })(state));

    const initialValues = useAmsSelector((state) => {
        const formInitializer = newGetInitialValues("guestRegistration");
        const inialValuesFactory = formInitializer(state);
        return inialValuesFactory({
            "rentcontractId": rentContractId,
            "registrationMode": "guestRegistration",

            [AccountFieldset.PREFIX_KEY]: "",
            [AccountFieldset.NAME]: "",
            [AccountFieldset.SURNAME]: "",
            [AccountFieldset.BIRTHDATE]: "",
            [AccountFieldset.PHONE]: "",
            [AccountFieldset.EMAIL]: "",
            [AddressFieldset.STREET]: "",
            [AddressFieldset.BUILDING]: "",
            [AddressFieldset.ZIP_CODE]: "",
            [AddressFieldset.CITY]: "",
            [AddressFieldset.COUNTRY_CODE]:"",

            [IdentificationAndDriversLicenseFieldset.IDENT_CARD_TYPE]: "",
            [IdentificationAndDriversLicenseFieldset.IDENT_CARD_NO]: "",
            [IdentificationAndDriversLicenseFieldset.IDENT_CARD_COUNTRY]: "",
            [IdentificationAndDriversLicenseFieldset.IDENT_CARD_AUTHORITY]: "",
            [IdentificationAndDriversLicenseFieldset.IDENT_CARD_DATE_ISSUED]: "",
            [IdentificationAndDriversLicenseFieldset.IDENT_CARD_VALID_TILL]: "",
            [IdentificationAndDriversLicenseFieldset.DRIVERS_LICENSE_NO]: "",
            [IdentificationAndDriversLicenseFieldset.DRIVERS_LICENSE_COUNTRY]: "",
            [IdentificationAndDriversLicenseFieldset.DRIVERS_LICENSE_DATE_ISSUED]: "",

            ...(hasField(AccountFieldset.TAX_IDENT) ? { [AccountFieldset.TAX_IDENT]: "" } : {}),

            "tosAccepted": false,

        });
    });

    return (
        <Formik initialValues={initialValues} validate={validate} onSubmit={onSubmit}>
            {(formikProps) => (
                <SignUpGuestForm {...formikProps} hasField={hasField} onCaptchaChange={onCaptchaChange} />
            )}
        </Formik>
    );
}

export default function B2C_SignUp_Guest() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const rentObject = useAmsSelector(getSelectedRentObject);

    const [captchaToken, setCaptchaToken] = useState();

    // the guest registration page is only available when user is in the booking process
    // this means he comes from another location and there is a rentObject selected
    useEffect(() => {
        if (!location?.state || rentObject === undefined) {
            navigate(B2C_SelectStationAndTime.path(),);
        }
    }, [location?.state, navigate, rentObject]);


    const onSubmit = useCallback(async (values, formikProps) => {
        let redirectPath = B2C_SelectStationAndTime.path();
        if (location.state?.from?.pathname) {
            redirectPath = B2C_STR_SubmitRentContract.path();
            if (location.state?.from?.pathname.indexOf('ltr') >= 0) {
                redirectPath = B2C_LTR_SubmitRentContract.path();
            }
        }
        values = { ...values, captchaToken };
        const nextPath = await dispatch(submitRegisterAsGuest(values, formikProps, redirectPath));
        if (nextPath === undefined) {
            return;
        }
        await dispatch(setLoginState());
        if (nextPath && nextPath.length > 0) {
            navigate(nextPath, { replace: true });
        }
    }, [captchaToken, dispatch, location.state?.from?.pathname, navigate]);

    const onCaptchaChange = useCallback((captchaToken) => {
        setCaptchaToken(captchaToken);
    }, []);

    const init = useCallback(async () => await dispatch(initializeGuestRegister()), [dispatch]);
    const isReady = useInitialize(init);
    if (!isReady) {
        return <ScreenLoading />;
    }

    return (
        <div>
            <ScreenSection main dark>
                <TypeArea>
                    <SignUpFormWrapper onSubmit={onSubmit}
                        onCaptchaChange={onCaptchaChange} />
                </TypeArea>
            </ScreenSection>

        </div>
    );
}
